import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import { ScreeningRejectImg } from '~/img';
import theme from '~/constants/theme';

const AllProductsOnboarded: FC = () => {
  const { t } = useTranslation('stageResult');

  return (
    <WizardContent
      content={
        <Container className="AllProductsOnboarded">
          <div className="AllProductsOnboarded-Content">
            <ScreeningRejectImg className="AllProductsOnboarded-Img" />
            <Typography.Title className="AllProductsOnboarded-Title">
              {t('This client is already onboarded for all available card products.')}
            </Typography.Title>
            <Typography.Paragraph className="AllProductsOnboarded-Paragraph">
              <Trans
                t={t}
                i18nKey="No further onboarding is allowed. For more info, please <1>contact support</1>."
              >
                {'No further onboarding is allowed. For more info, please '}
                <a href={features.contactUsLinkHardDecline} target="__blank">
                  contact support
                </a>
                .
              </Trans>
            </Typography.Paragraph>
          </div>
          <div className="AllProductsOnboarded-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} contactUsTextPosition="left" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .AllProductsOnboarded-Content {
    position: relative;
    .AllProductsOnboarded-Img {
      width: 100%;
      margin-bottom: 32px;
    }
    .AllProductsOnboarded-Title {
      position: absolute;
      top: 20%;
      left: 5%;
      width: 50%;
      color: #0060a8;
    }
    .AllProductsOnboarded-Paragraph {
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .AllProductsOnboarded-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .AllProductsOnboarded-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .AllProductsOnboarded-Paragraph {
        margin-left: 0;
      }
    }
  }
  .AllProductsOnboarded-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .AllProductsOnboarded-ContactUs {
      display: none;
    }
  }
`;

export default AllProductsOnboarded;
